
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners-terms-and-conditions",
      function () {
        return require("private-next-pages/partners-terms-and-conditions/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners-terms-and-conditions"])
      });
    }
  